//----------------------------------------
// search-tool.js
//----------------------------------------

var searchTimeout;

$('[data-search-content]').on('click', function(event){
    event.preventDefault();
    toggleSearchToolBar();
    setTimeout(()=>{
        openAllSections();
    }, 250)
})

$('[data-search-tool-open]').on('click', function(){
    toggleSearchToolBar();
    openAllSections();
})

$('[data-search-tool-close]').on('click', function(){
    toggleSearchToolBar();
})

$('input[data-search-tool-input]').on('input', function(event){
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function () {
        var searchWords = event.target.value;
        matchedSearchWords.resetSearch();
        if(searchWords !== ''){
            handleSearchWords(searchWords);
        }
    }, 1000);
})

$('input[data-search-tool-input]').on("keyup", function(event) {
    const ENTER_KEY = 13;

    if(matchedSearchWords.amountOfWords !== 0){
        if (event.keyCode === ENTER_KEY && event.shiftKey) {
            matchedSearchWords.getPreviousWord();
        } else if (event.keyCode === ENTER_KEY) {
            matchedSearchWords.getNextWord();
        }
    }
});

$('button[data-search-next]').on('click', function(){
    matchedSearchWords.getNextWord();
});

$('button[data-search-previous]').on('click', function(){
    matchedSearchWords.getPreviousWord();
});

const matchedSearchWords = {
    words: [],
    currentWord: 0,
    amountOfWords: 0,
    getPreviousWord: function(){
        if(this.words[this.currentWord].classList.contains('is-active')){
            this.words[this.currentWord].classList.remove('is-active');
        }

        if(this.currentWord - 1 < 0){
            this.currentWord = this.words.length - 1;
        } else {
            this.currentWord = this.currentWord - 1;
        }
        this.goToWord(this.words[this.currentWord]);
    },
    getNextWord: function(){
        if(this.words[this.currentWord].classList.contains('is-active')){
            this.words[this.currentWord].classList.remove('is-active');
        }

        if(this.currentWord + 1 == this.words.length){
            this.currentWord = 0;
        } else {
            this.currentWord = this.currentWord + 1;
        }
        this.goToWord(this.words[this.currentWord]);
    },
    goToWord: function(word){
        if(word !== undefined){
            word.classList.add('is-active');
            word.scrollIntoView({ block: "center" });
            updateSearchResultCurrentWordNum(this.currentWord);
        }
    },
    findClosestWord: function(){
        let currentBrowserPos = $(window).scrollTop();
        for(let i = 0; i < this.words.length; i++){
            let currentWord = this.words[i];
            let currentWordPos = $(currentWord).offset().top;
            
            if(currentWordPos >= currentBrowserPos){
                return [i, currentWord];
            }
        }
    },
    resetSearch: function(){
        $("#sections").unmark();
        updateSearchResultCount(0);
        toggleSearchNextPrevButtons(0);
        this.words.length = 0;
        this.currentWord = 0;
    }
}

function handleSearchWords(words){
    var options = {
        className: 'search-word',
        separateWordSearch: false,
        accuracy: {
            "value": "exactly",
            "limiters": [",", ".", "?", "s"]
        },
        exclude: [".tooltip-content"],
        each: function(node){
            if(htmlNodeIsHidden(node)){
                return false;
            } else if(node.innerText === ""){
                return false;
            } else {
                matchedSearchWords.words.push(node);
            };
        },
        noMatch: function(){
            $('.search-no-results-found').addClass('is-active');
        },
        done: function(counter){
            let amountOfWords = matchedSearchWords.words.length;

            updateSearchResultCount(amountOfWords);
            toggleSearchNextPrevButtons(amountOfWords);
            matchedSearchWords.amountOfWords = amountOfWords;

            if(amountOfWords !== 0){
                let [wordNum, closestWord] = matchedSearchWords.findClosestWord();
                matchedSearchWords.currentWord = wordNum;
                matchedSearchWords.goToWord(closestWord);
            } else {
                $('.search-no-results-found').addClass('is-active');
            }
        }
    }

    $("#sections").mark(words, options);
}

function toggleSearchNextPrevButtons(amountOfWords){
    const prevWordButton = $('button[data-search-previous]');
    const nextWordButton = $('button[data-search-next]');
    
    if(prevWordButton[0].hasAttribute('disabled') || nextWordButton[0].hasAttribute('disabled')){
        if(amountOfWords === 0){ return false; }
        prevWordButton.removeAttr('disabled');
        nextWordButton.removeAttr('disabled');
    } else {
        prevWordButton.attr('disabled', 'disabled');
        nextWordButton.attr('disabled', 'disabled');
    }
}

function updateSearchResultCurrentWordNum(currentWord){
    var searchResultCounter = $('.search-result-count');
    searchResultCounter.find('.current').text(currentWord + 1);
} 

function updateSearchResultCount(counter){
    var searchResultCounter = $('.search-result-count');
    var noSearchResult = $('.search-no-results-found');

    if(!searchResultCounter.hasClass('is-active')){
        searchResultCounter.addClass('is-active');
    }

    if(counter === 0){
        searchResultCounter.removeClass('is-active');
    } else {
        noSearchResult.removeClass('is-active');
        searchResultCounter.find('.total').text(counter);
    }
} 

function toggleSearchToolBar(){
    var searchToolBar = $('.search-tool-bar');
    var stickySearchButton = $('.search-button-sticky');

    if(searchToolBar.hasClass('is-active')){
        matchedSearchWords.resetSearch();
        searchToolBar.find('input[type="search"]').val('').blur();
        searchToolBar.removeClass('is-active');
        stickySearchButton.removeClass('search-is-open');
        $('body').removeClass('search-is-active');
    } else {
        searchToolBar.find('input[type="search"]').focus();
        searchToolBar.addClass('is-active');
        stickySearchButton.addClass('search-is-open');
        $('body').addClass('search-is-active');
    }
}
